import { Injectable } from '@angular/core';

@Injectable()
export class ZingChartService {

  public zingChartTheme = [];
  valueBox: object;
  config : any;
  constructor() {

    this.zingChartTheme = [{
      "palette": { // object
        "line": [ // Key is chart type name, value is array of arrays
          ["#ffffff", "#001242", "#001242", "#001242", "#001242"],
          ["#ffffff", "#EDB60F", "#EDB60F", "#EDB60F", "#EDB60F"],
          ["#ffffff", "#EC7913", "#EC7913", "#EC7913", "#EC7913"],
          ["#ffffff", "#06B655", "#06B655", "#06B655", "#06B655"],
          ["#ffffff",'#75c633', '#75c633', '#75c633', '#75c633'],
          ["#ffffff",'#ab6add', '#ab6add', '#ab6add', '#ab6add'],
          ["#ffffff",'#E2D51A', '#E2D51A', '#E2D51A', '#E2D51A'],
          ["#ffffff",'#f2e41f', '#f2e41f', '#f2e41f', '#f2e41f'],
          ["#ffffff",'#ae009c', '#ae009c', '#ae009c', '#ae009c']
        ],
        "pie": [ // Key is chart type name, value is array of arrays
          ["#ffffff", "#0F7AD1", "#0F7AD1", "#0F7AD1", "#0F7AD1"],
          ["#ffffff", "#001242", "#001242", "#001242", "#001242"],
          ["#ffffff", "#FF6B00", "#FF6B00", "#FF6B00", "#FF6B00"],
          ["#ffffff", "#00AF31", "#00AF31", "#00AF31", "#00AF31"],
          ["#ffffff", "#F5848C", "#F5848C", '#F5848C', '#F5848C'],
          ["#ffffff",'#ab6add', '#ab6add', '#ab6add', '#ab6add'],
          ["#ffffff",'#E2D51A', '#E2D51A', '#E2D51A', '#E2D51A'],
          ["#ffffff",'#f2e41f', '#f2e41f', '#f2e41f', '#f2e41f'],
          ["#ffffff",'#ae009c', '#ae009c', '#ae009c', '#ae009c']
        ],
        "ring": [ // Key is chart type name, value is array of arrays
          ["#ffffff", "#0F7AD1", "#0F7AD1", "#0F7AD1", "#0F7AD1"],
          ["#ffffff", "#EDB60F", "#EDB60F", "#EDB60F", "#EDB60F"],
          ["#ffffff", "#EC7913", "#EC7913", "#EC7913", "#EC7913"],
          ["#ffffff", "#06B655", "#06B655", "#06B655", "#06B655"],
          ["#ffffff",'#75c633', '#75c633', '#75c633', '#75c633'],
          ["#ffffff",'#ab6add', '#ab6add', '#ab6add', '#ab6add'],
          ["#ffffff",'#E2D51A', '#E2D51A', '#E2D51A', '#E2D51A'],
          ["#ffffff",'#f2e41f', '#f2e41f', '#f2e41f', '#f2e41f'],
          ["#ffffff",'#ae009c', '#ae009c', '#ae009c', '#ae009c']
        ],
        "hbar": [ // Key is chart type name, value is array of arrays
          ["#ffffff", "#001242", "#001242", "#001242", "#001242"],
          ["#ffffff", "#41479B", "#41479B", "#41479B", "#41479B"],
          ["#ffffff", "#54ABF3", "#54ABF3", "#54ABF3", "#54ABF3"],
          ["#ffffff", "#727AE4", "#727AE4", "#727AE4", "#727AE4"],
          ["#ffffff",'#75c633', '#75c633', '#75c633', '#75c633'],
          ["#ffffff",'#ab6add', '#ab6add', '#ab6add', '#ab6add'],
          ["#ffffff",'#E2D51A', '#E2D51A', '#E2D51A', '#E2D51A'],
          ["#ffffff",'#f2e41f', '#f2e41f', '#f2e41f', '#f2e41f'],
          ["#ffffff",'#ae009c', '#ae009c', '#ae009c', '#ae009c']
        ],
        "vbar": [ // Key is chart type name, value is array of arrays
          ["#009688", "#009688", "#009688", "#009688", "#009688"],
          ["#ffffff", "#41479B", "#41479B", "#41479B", "#41479B"],
          ["#ffffff", "#54ABF3", "#54ABF3", "#54ABF3", "#54ABF3"],
          ["#ffffff", "#727AE4", "#727AE4", "#727AE4", "#727AE4"],
          ["#ffffff",'#75c633', '#75c633', '#75c633', '#75c633'],
          ["#ffffff",'#ab6add', '#ab6add', '#ab6add', '#ab6add'],
          ["#ffffff",'#E2D51A', '#E2D51A', '#E2D51A', '#E2D51A'],
          ["#ffffff",'#f2e41f', '#f2e41f', '#f2e41f', '#f2e41f'],
          ["#ffffff",'#ae009c', '#ae009c', '#ae009c', '#ae009c']
        ],
        "area": [ // Key is chart type name, value is array of arrays
          ["#ffffff", "#001242", "#001242", "#001242", "#001242"],
          ["#ffffff", "#727AE4", "#727AE4", "#727AE4", "#727AE4"],
          ["#ffffff", "#54ABF3", "#54ABF3", "#54ABF3", "#54ABF3"],
          ["#ffffff", "#41479B", "#41479B", "#41479B", "#41479B"],
          ["#ffffff",'#75c633', '#75c633', '#75c633', '#75c633'],
          ["#ffffff",'#ab6add', '#ab6add', '#ab6add', '#ab6add'],
          ["#ffffff",'#E2D51A', '#E2D51A', '#E2D51A', '#E2D51A'],
          ["#ffffff",'#f2e41f', '#f2e41f', '#f2e41f', '#f2e41f'],
          ["#ffffff",'#ae009c', '#ae009c', '#ae009c', '#ae009c']
        ],
      }
    }];

    this.valueBox = {
      "text": "%npv%",
      "shadow": false,
      "padding": "3%",
      "font-size": "12pt"
    };

    this.config ={
      behaviors: [
        {
          id: "Reload", //built-in id
          enabled:"none" //sets visibility to show
        },
        {
          id: "SaveAsImage",
          enabled:"none"
        },
        {
          id: "DownloadPDF", //built-in id
          enabled: "none" //sets visibility to show
        },
        {
          id: "DownloadSVG",
          enabled: "none"
        },
        {
          id: "Print",
          enabled: "none"
        },
        {
          id: "ViewSource", //built-in id
          enabled: "none" //sets visibility to hide
        },
        {
          id: 'showAlert',
          enabled: 'none'
        }
      ]
    }
  }

  getZingChartTheme() {
    // console.log(this.zingChartTheme[0]);
    return this.zingChartTheme[0];
  }

  public getConfigProperty(){
    return  {contextMenu: {
      button: {
        visible: false
      }
    }}
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/zing-chart.service.ts